import { DataBean } from "../DataBean";

export class PayrollImportedDataCatalog extends DataBean {



    public async getPayrollImportedDataCatalog(idAccount: any, state: any, year: any, month: any, regexStr: any, page: any, recordsPerPage: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.advantage.shared.Report_getPayrollImportedDataCatalog_Number_Number_Number_Number_String_Number_Number", [idAccount, state, year, month, regexStr, page, recordsPerPage]);
    }

}
